
import * as customProviderRuntime$iuYUxJWANy from '/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/node_modules/sitis-nuxt-3/providers/imageProvider.ts'
import * as localProviderRuntime$iuYUxJWANy from '/var/www/new.mia-sofia.ru/miasofiaru-front-20260924114549/node_modules/sitis-nuxt-3/providers/imageProvider.ts'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "imageProvider",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['imageProvider']: { provider: customProviderRuntime$iuYUxJWANy, defaults: {"modifiers":{"format":"webp"},"baseURL":"https://mia-sofia.ru/api/storage/image/","emptyImagePlaceholder":"/img/placeholder.svg"} },
  ['localProvider']: { provider: localProviderRuntime$iuYUxJWANy, defaults: undefined }
}
        